import { render, staticRenderFns } from "./TerrainQuestionField.vue?vue&type=template&id=fa356a32&scoped=true"
import script from "./TerrainQuestionField.vue?vue&type=script&lang=js"
export * from "./TerrainQuestionField.vue?vue&type=script&lang=js"
import style0 from "./TerrainQuestionField.vue?vue&type=style&index=0&id=fa356a32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa356a32",
  null
  
)

export default component.exports